import React, { Component } from "react";
import {
  InputGroup,
  InputGroupAddon,
  Input,
  Row,
  Col,
  Button,
  Table
} from "reactstrap";
import { reduxForm } from 'redux-form'
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import Collapsible from 'react-collapsible';
import BlockUi from 'react-block-ui';
import Pagination from "react-js-pagination";
import { NGANHHANG_LIST_SUCCESS } from './constants'
import * as nganhHangAction from './actions'
import { storedb } from '../../views/client/storedb'
import DisplayRecordText from "../controls/_DisplayRecordText"
import { BtnPermissions, BtnType } from '../../lib/BtnPermissions';
import { ButtonExt } from "../controls/ButtonExt"

class NganhHang extends Component {
  static propTypes = {
    handleSubmit: PropTypes.func.isRequired,
    nganhHangListRequest: PropTypes.func,
    nganhHangUpdateRequest: PropTypes.func,
    nganhHang: PropTypes.shape({
      list: PropTypes.array,
      item: PropTypes.object,
      type: PropTypes.string,
      listRequesting: PropTypes.bool,
      requesting: PropTypes.bool,
      successful: PropTypes.bool,
      messages: PropTypes.array,
      errors: PropTypes.array,
    }),
  }
  constructor(props) {
    super(props);
    var dbContext = storedb();
    this.state = {
      stores_id: dbContext.getStoreId(),
      item: {},
      list: [],
      TrangThaiId: '',
      keyword: '',
      per_page: 20,
      page: 1,
      total_record: 0
    };
  }
  handlePageChange = (pageNumber) => {
    let page = parseInt(pageNumber || 1)
    return this.setState({ page }, this.fetchList);
  }
  handleSearchChange = (name, e, value) => {
    switch (name) {
      case "keyword":
        this.setState({ keyword: e.target.value });
        break;
      default:
        break;
    }
  }
  handleSelectChange = (name, selectedOption) => {
    switch (name) {
      case "TrangThai":
        this.setState({ TrangThaiId: selectedOption.target.value })
        break;
      default:
        break;
    }
  }
  fetchList = () => {
    const { nganhHangListRequest } = this.props

    var requestData = {
      StoreId: this.state.stores_id,
      keyword: this.state.keyword,
      status: this.state.TrangThaiId,
      page: this.state.page,
      per_page: this.state.per_page
    };
    return nganhHangListRequest(requestData);
  }
  search = () => {
    if (this.props.nganhHang.listRequesting) {
      return false;
    }
    return this.fetchList()
  }
  refresh = () => {
    this.setState({
      stores_id: this.state.stores_id,
      keyword: '',
      TrangThaiId: '',
      page: this.state.page,
      per_page: this.state.per_page
    }, () => {
      if (this.props.nganhHang.listRequesting) {
        return false;
      }
      return this.fetchList()
    })
  }
  onChangeItem = (itemPerPage) => {
    this.setState({ per_page: itemPerPage }, () => {
      this.search();
    });
  }
  EditNganhHangItem = (item) => {
    this.props.history.push('/nganhhang-edit?nganhhang=' + (item.NganhHangId || ""));
  }
  componentDidMount() {
    this.fetchList();
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.nganhHang.type == NGANHHANG_LIST_SUCCESS) {
      let { list, item } = nextProps.nganhHang;
      this.setState({
        page: item.page,
        per_page: item.per_page,
        total_record: item.total_record,
        list: list
      });
    }
  }
  render() {
    const {
      handleSubmit,
      nganhHang: {
        listRequesting,
        list
      },
    } = this.props
    return (
      <div className="animated fadeIn">
        <BlockUi tag="div" blocking={listRequesting} >
          <div>
            <Collapsible trigger="Tìm kiếm..." open={true}>
              <Row>
                <Col sm="8" className="mb-2">
                  <InputGroup size="md">
                    <InputGroupAddon addonType="prepend" autoComplete="off" >Tên nhóm sản phẩm</InputGroupAddon>
                    <Input name="keyword" autoComplete="off" value={this.state.keyword} onChange={this.handleSearchChange.bind(this, "keyword")} />
                  </InputGroup>
                </Col>
                <Col sm="4" className="mb-2">
                  <InputGroup size="md">
                    <InputGroupAddon addonType="prepend">Trạng thái</InputGroupAddon>
                    <select className="form-control" value={this.state.TrangThaiId} onChange={this.handleSelectChange.bind(this, "TrangThai")}>
                      <option value="">Trạng thái</option>
                      <option value={0}>Hoạt động</option>
                      <option value={1}>Ngừng hoạt động</option>
                    </select>
                  </InputGroup>
                </Col>
              </Row>
            </Collapsible>
          </div>
          <div className="mt-2 bg-white">
            <div className="w-100 mb-2">
            <Button size="md" color="success" className="pull-left mr-1" 
              onClick={handleSubmit(this.search)}><i className="fa fa-search"></i> Tìm kiếm</Button>
              <ButtonExt btnClass="mr-1"
                color="primary"
                iconClass="fa-plus"
                displayText="Thêm mới"
                btnClick={() => this.EditNganhHangItem({})}
                permission={BtnPermissions.NganhHang.ADD_OR_UPDATE} />
            </div>
            <div className="w-100">
              <DisplayRecordText
                itemsCountPerPage={this.state.per_page}
                onChangeItem={this.onChangeItem}
              />
              <Table hover responsive className="table-outline mb-0 d-sm-table table-sm">
                <thead className="thead-default">
                  <tr>
                    <th scope="col" width="50" className="text-center">#</th>
                    <th scope="col" className="text-left">Tên nhóm sản phẩm</th>
                    <th scope="col" width="80" className="text-center">Trạng thái</th>
                    <th scope="col" width="20" className="text-center">Sửa</th>
                  </tr>
                </thead>
                <tbody>
                  {list && !!list.length && (
                    list.map((res, idx) => (
                      <tr key={idx + 1}>
                        <td className="text-center">{idx + 1}</td>
                        <td className="text-left">{res.Ten}</td>
                        <td className="text-center">
                          {res.IsDeleted == 1 ? <span className="text-danger"><i className="fa fa-close"></i></span> : <span className="text-success"><i className="fa fa-check"></i></span>}
                        </td>
                        <td scope="row" className="text-center">
                          <ButtonExt 
                            btnClass="text-primary mr-1"
                            iconClass="fa-edit"
                            btnType={BtnType.ButtonLink}
                            btnClick={() => this.EditNganhHangItem(res)}
                            permission={BtnPermissions.NganhHang.ADD_OR_UPDATE} />
                        </td>
                      </tr>
                    ))
                  )}
                </tbody>
                <tfoot>
                  <tr>
                    <td colSpan="4">
                      <span className="text-success mr-2"><i className="fa fa-check"></i> = Đang hoạt động</span>
                      <span className="text-danger"><i className="fa fa-close"></i> = Dừng hoạt động</span>
                    </td>
                  </tr>
                </tfoot>
              </Table>
              {this.state.total_record > this.state.per_page && (
                <Pagination
                  activePage={this.state.page}
                  itemsCountPerPage={this.state.per_page}
                  totalItemsCount={this.state.total_record}
                  pageRangeDisplayed={5}
                  onChange={this.handlePageChange}
                />
              )}
            </div>
            <div className="clearfix"></div>
          </div>
        </BlockUi>
      </div>
    )
  }
}
const mapStateToProps = state => ({
  nganhHang: state.nganhHang,
  client: state.client,
})
const connected = connect(mapStateToProps, {
  nganhHangListRequest: nganhHangAction.nganhHangListRequest,
  nganhHangUpdateRequest: nganhHangAction.nganhHangUpdateRequest,
})(NganhHang)
const formed = reduxForm({
  form: 'nganhHang',
})(connected)
export default formed;



// WEBPACK FOOTER //
// ./src/views/NganhHang/NganhHang.js